import React from 'react';
import {FormGroup, Input, Label} from 'reactstrap';
import languageOptions from '../../lib/languageOptions';

interface LanguagePickerProps {
    selected: string;
    other: string;
    onSelectedChange: (value: string) => void;
    onOtherChange: (value: string) => void;
}

// The translator's language list, with "Other" for one that isn't on it.
const LanguagePicker: React.FC<LanguagePickerProps> = ({
    selected,
    other,
    onSelectedChange,
    onOtherChange
}) => (
    <FormGroup className="mb-0">
        <Label for="languageSelect">Select Language</Label>
        <Input
            type="select"
            id="languageSelect"
            value={selected}
            onChange={e => onSelectedChange(e.target.value)}
        >
            <option value="">Select a language</option>
            {languageOptions.map(option => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
            <option value="Other">Other</option>
        </Input>
        {selected === 'Other' && (
            <Input
                type="text"
                id="otherLanguage"
                placeholder="Enter another language"
                value={other}
                onChange={e => onOtherChange(e.target.value)}
                className="mt-2"
            />
        )}
    </FormGroup>
);

export default LanguagePicker;
